// Web stub for react-native-network-logger
const NetworkLogger = () => null
export const startNetworkLogging = () => {}
export const stopNetworkLogging = () => {}
export const getBackHandler = () => () => {}
export default NetworkLogger
